module.exports = __webpack_public_path__ + "img/notify.462da60f.png";